export { default } from "./AboutDispensary";
